import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Navigation } from '../../../global-functions';
import { serviceRequestTypes } from '../../common/constants';
import SelectInput from '../../inputs/select-input';

const ServiceRequestSelect = () => {
    const intl = useIntl();
    const [serviceRequestTypeState, setServiceRequestTypeState] =
        useState<string>(serviceRequestTypes[3].text);

    return (
        <>
            <h1>
                {intl.formatMessage({
                    id: 'Color_Exchange',
                    defaultMessage: 'Color Exchange',
                })}
            </h1>
            <div className="well">
                <div className="form-horizontal">
                    <SelectInput
                        name="serviceRequestChoice"
                        label="Action"
                        labelClassName="control-label col-sm-4 col-md-3"
                        fieldClassName="col-sm-8 col-md-6"
                        options={serviceRequestTypes}
                        hasDefaultOption={false}
                        value={serviceRequestTypeState}
                        onChange={(e) => {
                            setServiceRequestTypeState(e.target.value);
                            serviceRequestTypes
                                .filter((item) => item.value === e.target.value)
                                .map((item) => {
                                    if (item.url)
                                        return Navigation.pushExternal(
                                            item!.url
                                        );
                                });
                        }}
                        required={false}
                    />
                </div>
            </div>
        </>
    );
};

export default ServiceRequestSelect;
